import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios'
import { makeStyles } from '@material-ui/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  controlLabel: {
    width: 300
  },
  formControl: {
    marginTop: 5
  }
}));

const TypePersonData = props => {
  const classes = useStyles();
  const { financeuser, getTypePersonValue } = props;
  const [checklist, setChecklist] = useState([]);
  const [values, setValues] = useState([]);
  const [state, setState] = useState({});

  let source = axios.CancelToken.source();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await loadData()
        await getFinanceUser(financeuser, data);
        return () => {
          source.cancel();
        };
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, [financeuser]);

  const loadData = async () => {
    const url = 'https://eslip.snru.ac.th/backend/api/users/typepersons';
    try {
      const result = await axios(url, {
        cancelToken: source.token
      });
      return result.data.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getFinanceUser = async (person, typePerson) => {
    let obj = {};
    let obj2 = {};
    const url = 'https://eslip.snru.ac.th/backend/api/financeTypePerson/' + person.person.citizen_id;
    try {
      const response = await axios.get(url, {
        cancelToken: source.token
      });
      response.data.data.map(element => {
        obj = { ...obj, [element.type_person_id]: false }
        obj2 = { ...obj2, [element.type_person_id]: element.type_person_id.toString() }
      });
      setState({ ...state, ...obj });
      const result = Object.values(obj2);
      //setValues(result);
      const data = filter(typePerson, { type_person_id: result });
      setChecklist(data);
      getTypePersonValue();
    } catch (error) {
      console.log(error)
    }
  }

  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
    const index = values.indexOf(event.target.value);
    (event.target.checked) ? (values.push(event.target.value)) : (values.splice(index, 1))
    getTypePersonValue(values);
  };

  const getValue = value => (typeof value === 'string' ? value.toUpperCase() : value);

  const filter = (array, filters) => {
    const filterKeys = Object.keys(filters);
    return array.filter(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].find(filter => getValue(filter) === getValue(item[key]));
      });
    });
  }

  return (
    <div className={classes.root}>
      <FormControl component="fieldset">
        <FormLabel component="legend"><h3>ประเภทบุคลากร</h3></FormLabel>
        <FormGroup aria-label="position" name="position" row>
          {
            checklist.map((TypePerson, i) =>
              <FormControlLabel key={i} className={classes.controlLabel}
                control={
                  <Checkbox
                    checked={state[TypePerson.type_person_id] || false}
                    onChange={handleChange(TypePerson.type_person_id)}
                    value={TypePerson.type_person_id}
                    color="primary"
                  />
                }
                label={TypePerson.type_person_name}
              />)
          }
        </FormGroup>
      </FormControl>
    </div>
  );
};

TypePersonData.propTypes = {
  financeuser: PropTypes.object,
  getTypePersonValue: PropTypes.func
};

export default TypePersonData;